<!--
 * @Author: Junjie
 * @Date: 2022-06-18 16:00:41
 * @LastEditTime: 2022-06-18 17:04:58
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/plant/overview.vue
-->
<template>
  <page-layout :logo="plantInfo.plLogo" :title="plantInfo.plName">
    <detail-list :col="2" class="detail-layout" size="small" slot="headerContent">
      <detail-list-item term="负责人">{{plantInfo.plLeader_dictText}}</detail-list-item>
      <detail-list-item term="设计日处理量(m³/天)">{{plantInfo.plCapacity}}</detail-list-item>
      <detail-list-item term="投运日期">{{plantInfo.plDate}}</detail-list-item>
      <detail-list-item term="运行状态">
        <span v-if="plantInfo.plStatus==0">
          <a-tag color="#faad14">停运</a-tag>
        </span>
        <span v-else>
          <a-tag color="#52c41a">运行中</a-tag>
        </span>
      </detail-list-item>

      <a-button type="link">
        <router-link to="/alert/center">告警中心</router-link>
      </a-button>
      <a-button type="link">
        <router-link to="/general/process">工艺看板</router-link>
      </a-button>
      <a-button type="link">设备看板</a-button>
      <a-button type="link">
        <router-link to="/process/all">工单中心</router-link>
      </a-button>
      <a-button type="link">
        <router-link to="/video/ys-live">视频监控</router-link>
      </a-button>
    </detail-list>

    <a-card :style="{ marginTop: '24px' }">
      <a-row>
        <a-col :span="6">
          <chart-card title="今日进水量" total="126,5.3">
            <div>
              <trend flag="up" style="margin-right: 16px;">
                <span slot="term">比上周</span>
                12%
              </trend>
              <trend flag="down">
                <span slot="term">比昨日</span>
                11%
              </trend>
            </div>
          </chart-card>
        </a-col>
        <a-col :span="6">
          <chart-card title="今日出水量" total="126,5.3">
            <div>
              <trend flag="up" style="margin-right: 16px;">
                <span slot="term">比上周</span>
                12%
              </trend>
              <trend flag="down">
                <span slot="term">比昨日</span>
                11%
              </trend>
            </div>
          </chart-card>
        </a-col>
        <a-col :span="6">
          <chart-card title="今日泥量" total="34">
            <div>
              <trend flag="up" style="margin-right: 16px;">
                <span slot="term">比上周</span>
                12%
              </trend>
              <trend flag="down">
                <span slot="term">比昨日</span>
                11%
              </trend>
            </div>
          </chart-card>
        </a-col>
        <a-col :span="6">
          <chart-card title="设备完好率" total="98%">
            <div>
              <mini-progress :height="8" :percentage="98" :target="80" color="rgb(19, 194, 194)" />
            </div>
          </chart-card>
        </a-col>
      </a-row>
    </a-card>

    <a-card :style="{ marginTop: '24px' }">
      <a-row>
        <a-col :span="6">
          <a-card :bordered="false" title="告警统计">
            <div class="no-data">
              <a-icon type="frown-o" />暂无数据
            </div>
          </a-card>
        </a-col>
        <a-col :span="18">
          <a-card :bordered="false" title="未处理告警">
            <div class="no-data">
              <a-icon type="frown-o" />暂无数据
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
  </page-layout>
</template>

<script>
  import PageLayout from '@/components/page/PageLayout'
  import { httpAction, getAction } from '@/api/manage'


  import ChartCard from '@/components/ChartCard'
  import ACol from "ant-design-vue/es/grid/Col"
  import ATooltip from "ant-design-vue/es/tooltip/Tooltip"
  import MiniArea from '@/components/chart/MiniArea'
  import MiniBar from '@/components/chart/MiniBar'
  import MiniProgress from '@/components/chart/MiniProgress'
  import RankList from '@/components/chart/RankList'
  import Bar from '@/components/chart/Bar'
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import HeadInfo from '@/components/tools/HeadInfo.vue'
  import Trend from '@/components/Trend'
  import DetailList from '@/components/tools/DetailList'

  const DetailListItem = DetailList.Item
  export default {
    name: "Overview",
    components: {
      PageLayout,
      DetailList,
      DetailListItem,
      ATooltip,
      ACol,
      ChartCard,
      MiniArea,
      MiniBar,
      MiniProgress,
      RankList,
      Bar,
      Trend,
      LineChartMultid,
      HeadInfo
    },
    data () {
      return {
        plantInfo: {},
        url: {
          list: "/device/sewegePlantList/list",
          add: "/device/sewegePlantList/add",
          edit: "/device/sewegePlantList/edit",
          queryById: "/device/sewegePlantList/queryById"
        }

      }
    }, created () {
      this.loadSewegeInfo();
    },
    methods: {
      loadSewegeInfo () {
        getAction(this.url.list, {}).then(res => {
          if (res.success) {
            const originMedel = res.result.records[0];
            if (originMedel) {
              this.plantInfo = originMedel;
            }
          } else {
            this.$message.error(res.message)
          }

        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .detail-layout {
    margin-left: 44px;
  }
  .text {
    color: rgba(0, 0, 0, 0.45);
  }

  .heading {
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
  }

  .no-data {
    color: rgba(0, 0, 0, 0.25);
    text-align: center;
    line-height: 64px;
    font-size: 16px;

    i {
      font-size: 24px;
      margin-right: 16px;
      position: relative;
      top: 3px;
    }
  }

  .mobile {
    .detail-layout {
      margin-left: unset;
    }
    .status-list {
      text-align: left;
    }
  }
</style>